import React from 'react';
import SearchableSelect from '../SearchableSelect/SearchableSelect';

export interface IOption {
    value: number;
    label: string;
}

interface Props {
    options: IOption[];
    value: IOption | null;
    onSelect: (option: IOption | null) => void;
    placeholder?: string;
    disabled?: boolean;
    readOnly?: boolean;
    leadingIcon?: React.ReactNode | null;
    emptyLabel?: string;
    className?: string;
}

const OptionSelect: React.FC<Props> = ({
    options,
    value,
    onSelect,
    placeholder,
    disabled,
    readOnly,
    leadingIcon,
    emptyLabel = 'לא נמצא דבר',
    className,
}) => (
    <SearchableSelect<IOption>
        items={options}
        value={value}
        onSelect={onSelect}
        getKey={(o) => o.value}
        getLabel={(o) => o.label}
        placeholder={placeholder}
        disabled={disabled}
        readOnly={readOnly}
        leadingIcon={leadingIcon}
        emptyLabel={emptyLabel}
        className={className}
    />
);

export default OptionSelect;
